"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _Box = _interopRequireDefault(require("../Box"));

var _checkIcons = _interopRequireDefault(require("./checkIcons"));

var _styles = require("./styles");

var _excluded = ["id", "name", "colorLabel", "className", "label", "disabled", "labelFontSize", "size", "status", "variant", "style", "onChange"];
var Checkbox = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, ref) {
  var id = _ref.id,
      name = _ref.name,
      colorLabel = _ref.colorLabel,
      className = _ref.className,
      label = _ref.label,
      disabled = _ref.disabled,
      labelFontSize = _ref.labelFontSize,
      size = _ref.size,
      status = _ref.status,
      variant = _ref.variant,
      style = _ref.style,
      _onChange = _ref.onChange,
      rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      isChecked = _useState2[0],
      setIsChecked = _useState2[1];

  var Icon = _checkIcons.default[variant];
  var checkboxId = id !== null && id !== void 0 ? id : name;
  var fieldClassNames = [];

  if (isChecked) {
    fieldClassNames.push("checked");
  }

  if (disabled) {
    fieldClassNames.push("disabled");
  }

  return /*#__PURE__*/_react.default.createElement(_Box.default, {
    paddingType: "square",
    paddingSize: "none",
    style: style,
    className: className
  }, /*#__PURE__*/_react.default.createElement(_styles.Label, {
    status: status,
    colorLabel: colorLabel,
    htmlFor: checkboxId,
    size: size,
    labelFontSize: labelFontSize
  }, /*#__PURE__*/_react.default.createElement(_styles.CheckboxStyled, {
    checked: isChecked,
    disabled: disabled,
    className: fieldClassNames.join(' ')
  }, /*#__PURE__*/_react.default.createElement(Icon, null)), /*#__PURE__*/_react.default.createElement(_styles.CheckboxHidden, Object.assign({
    ref: ref,
    id: checkboxId,
    name: name,
    type: "checkbox",
    disabled: disabled,
    onChange: function onChange(e) {
      setIsChecked(e.target.checked);
      _onChange === null || _onChange === void 0 ? void 0 : _onChange(e);
    }
  }, rest)), label));
});
Checkbox.defaultProps = {
  className: '',
  label: '',
  variant: 'check'
};
Checkbox.displayName = 'Checkbox';
var _default = Checkbox;
exports.default = _default;